import { ActionTree } from 'vuex';
import { basePath, Item, ModuleState } from './types';
import { RootState } from '@/types';
import { API, handleError } from '@/helpers/axios'

export const actions: ActionTree<ModuleState, RootState> = {
  async create({ commit }, item: Item) {
    try {
      const response = await API.post(`${basePath}/create`, item)
      if (response.status === 200) commit('handleResponse', { items: response.data })
    }
    catch(error) { handleError(error) }
  },
  async delete({ dispatch }, itemId: number) {
    try {
      const response = await API.post(`${basePath}/delete`, itemId)
      if (response.status === 200) dispatch('fetch')
    }
    catch(error) { handleError(error) }
  },
  async fetch({ commit }) {
    try {
      const response = await API.get(`${basePath}`)
      if (response.status === 200) commit('handleResponse', { items: response.data })
    }
    catch(error) { handleError(error) }
  },
  async update({ dispatch }, item: Item) {
    try {
      const response = await API.post(`${basePath}/update`, item)
      if (response.status === 200) dispatch('fetch')
    }
    catch(error) { handleError(error) }
  }
}
